<template>
  <div v-if="!file.upload">
    <b-dropdown v-if="!file.status && file.active" variant="-ternary btn--outline btn--dots no--arr"
                size="-small" text="⋮" right>
      <b-dropdown-group :header="$t('files.base.apps')" v-if="isStl">
        <b-dropdown-item-button  @click="repair()">
          <font-awesome-icon icon="magic" fixed-width/>
          {{$t('apps.magicFix.appName')}}
        </b-dropdown-item-button>

        <!--<b-dropdown-item-button @click="handleShowStlEditor" v-if="isStl">-->
          <!--<font-awesome-icon icon="arrows-alt" fixed-width/>-->
          <!--{{$t('apps.editor.appName')}}-->
        <!--</b-dropdown-item-button>-->
        <!--<b-dropdown-item-button @click="handleShowCloudSlicer" v-if="isStl">-->
          <!--<font-awesome-icon icon="cog" fixed-width/>-->
          <!--Cloud Slicer-->
        <!--</b-dropdown-item-button>-->
        <!--<b-dropdown-item-button v-if="isStl" @click="handleShowSlicer3">-->
          <!--<font-awesome-icon icon="cogs" fixed-width/>-->
          <!--{{$t('apps.slicer.appName')}}-->
        <!--</b-dropdown-item-button>-->
        <!--<b-dropdown-item-button v-if="isStl" @click="handlerShowCloudMbotSlicer">-->
          <!--<font-awesome-icon icon="cogs" fixed-width/>-->
          <!--Slicer for Makerbots-->
        <!--</b-dropdown-item-button>-->
        <!--<b-dropdown-item-button v-if="isStl" @click="handleOpenQuickPrint">-->
          <!--<font-awesome-icon icon="bolt" fixed-width/>-->
          <!--Quick Print-->
        <!--</b-dropdown-item-button>-->
        <!--<b-dropdown-item-button @click="handleShowToolpathViewer" v-if="isGcode">-->
          <!--<font-awesome-icon :icon="['fab','connectdevelop']" fixed-width/>-->
          <!--{{$t('apps.toolpath.appName')}}-->
        <!--</b-dropdown-item-button>-->
      </b-dropdown-group>
      <b-dropdown-group  :header="$t('files.base.actions')">
        <b-dropdown-item-button>
          <file-rename-button :file="file"></file-rename-button>
        </b-dropdown-item-button>
        <b-dropdown-item-button>
          <file-download-button :file="file"></file-download-button>
        </b-dropdown-item-button>
        <b-dropdown-item-button @click="share()">
          <font-awesome-icon icon="share-alt" fixed-width/>
          {{$t('buttons.share')}}
        </b-dropdown-item-button>
        <b-dropdown-item-button @click="deleteFile(file.id)">
          <font-awesome-icon icon="trash-alt" fixed-width/>
          <span v-if="file.owner">{{$t('buttons.removed')}}</span>
          <span v-else>{{$t('buttons.unshare')}}</span>
        </b-dropdown-item-button>
      </b-dropdown-group>
    </b-dropdown>
    <b-button v-else-if="!file.active" @click="undoFile(file.id)" size="-small"
              variant="-secondary">{{$t('buttons.undo')}}
    </b-button>
    <b-button v-else size="-small" variant="-secondary">{{$t('buttons.stop')}}</b-button>

    <!--<b-popover class="popover popover&#45;&#45;applications" target="1" triggers="click" placement="bottomleft">-->
    <!--<template v-slot:title>Applications</template>-->
    <!--<div class="popover&#45;&#45;applications__item">-->
    <!--<img src="https://live-cdn-3dprinteros.azureedge.net/assets/apps/virtualfactory/ico.png"-->
    <!--width="94" height="99" alt="Print through Industrial printers Factory">-->
    <!--<h6>Print through Industrial printers Factory</h6>-->
    <!--</div>-->
    <!--</b-popover>-->
    <b-modal v-model="sharingShow" size="lg" hide-footer>
      <share-file :file-id="file.id"></share-file>
    </b-modal>
    <b-modal v-model="repairShow" size="lg"  title="Magic fix" hide-footer>
      <template v-slot:modal-title>
        Magic Fix
      </template>
      <repair-file :file-id="file.id"></repair-file>
    </b-modal>
  </div>
  <div v-else-if="file.show_select_printers && file.upload">
    <b-button size="-small" variant="-secondary  btn--outline" :disabled="uploadUpdateProcess" @click="saveUpload">{{$t('buttons.save')}}</b-button>
  </div>
</template>

<script>
  import ShareFile from '@/components/files/modal/ShareFile'
  import FileMixin from "@/mixins/file";
  import ApplicationMixin from "@/mixins/application";
  //import FileRenameButton from '@/components/files/FileRenameButton'
  import FileDownloadButton from '@/components/files/FileDownloadButton'
  import FileRenameButton from '@/components/files/FileRenameButton'
  import RepairFile from '@/components/files/modal/RepairFile'
  import { mapActions} from 'vuex';
  export default {
    name: "FileActionButtons",
    props: ['file'],
    mixins: [FileMixin, ApplicationMixin],
    components: {FileDownloadButton, FileRenameButton, ShareFile, RepairFile},
    data(){
      return{
        sharingShow: false,
        repairShow: false,
        uploadUpdateProcess: false
      }
    },
    computed: {
      isGcode() {
        return this.isGcodeFileType(this.file.file_type_id);
      },
      isStl() {
        return this.isStlFileType(this.file.file_type_id);
      },
      hasApps() {
        return this.isGcode || this.isStl;
      }
    },
    methods: {
      ...mapActions(['deleteFile', 'undoFile','updateSlicerWeight', 'saveUploadUpdate']),
      share() {
        this.sharingShow = true;
      },
      repair() {
        this.repairShow = true;
      },
      handleShowStlEditor() {
        this.oldApps_showStlEditor(this.file.id, this.file.filename);
      },
      handleShowCloudSlicer() {
        this.updateSlicerWeight('cloud');
        this.oldApps_showCloudSlicer(this.file.id, null, 'slicer', this.file.filename);
      },
      handlerShowCloudMbotSlicer(){
        this.oldApps_showCloudMbotSlicer(this.file.id, null, 'slicer', this.file.filename)
      },
      handleShowToolpathViewer() {
        this.oldApps_showToolpathViewer(this.file.id, this.file.filename);
      },
      handleOpenQuickPrint() {
        window.vueOpenQuickPrint(this.file.id);
      },
      saveUpload(){
        this.uploadUpdateProcess = true;
        this.saveUploadUpdate(this.file).then(() => {
          this.uploadUpdateProcess = false;
          this.$emit('forceUpdateFiles');
        }).catch(() => {
          this.uploadUpdateProcess = false;
        })
      },
    }
  }
</script>

<style scoped>

</style>
